import React, { useEffect, useRef } from "react";
import Lottie from "lottie-web";
const Animation2 = () => {

    const container = useRef( null );
    useEffect( () => {
        Lottie.loadAnimation( {
            container: container.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require( './Animation 2.json' )

        } )
    }, [] );
    return (
        <>
            <div className="polygon-art" ref={container} >
            </div>
        </>
    )
}

export default Animation2